// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".RoutesWrapper-zenWrapper-S3Rpl {\n  transition: opacity 0.3s;\n  position: absolute;\n  left: 0;\n  right: 0;\n  min-height: 100vh;\n  opacity: 1;\n  z-index: 601;\n  background-color: white;\n}\n@starting-style {\n  .RoutesWrapper-zenWrapper-S3Rpl {\n    opacity: 0;\n  }\n}\n.RoutesWrapper-zenWrapperHidden-3xnwe {\n  opacity: 0;\n  pointer-events: none;\n}\n.RoutesWrapper-content-22aS7 {\n  opacity: 1;\n  transition: opacity 0.2s;\n  transition-delay: 0.3s;\n}\n@starting-style {\n  .RoutesWrapper-content-22aS7 {\n    opacity: 0;\n  }\n}\n", ""]);
// Exports
exports.locals = {
	"zenWrapper": "RoutesWrapper-zenWrapper-S3Rpl",
	"zenWrapperHidden": "RoutesWrapper-zenWrapperHidden-3xnwe RoutesWrapper-zenWrapper-S3Rpl",
	"content": "RoutesWrapper-content-22aS7"
};
module.exports = exports;
